export interface BatchReturnDbUpdateRequest {
  outputMode: string
  fileName: string
  batchType: string
}

export function BatchReturnDbUpdateRequestToJSON(
  value: BatchReturnDbUpdateRequest
): any {
  return {
    output_mode: value.outputMode,
    file_name: value.fileName,
    batch_type: value.batchType
  }
}
